export default "__VITE_ASSET__BS98sQA7__"